/* Daza Organic · «Nuestra historia»: los capítulos del timeline avanzan
   solos cada cierto tiempo (data-autoplay, en ms), con flechas y una barra
   de progreso segmentada (estilo «stories») que dice tanto en qué capítulo
   estás como CUÁNDO va a cambiar el siguiente. Pausa con hover/foco y con
   prefers-reduced-motion (ahí solo queda la navegación manual, sin barra
   animada). Sin librerías: un custom element vanilla, mismo patrón que
   daza-pasos-ciclo y daza-porque-carrusel.

   La barra se anima con un @keyframes en CSS (daza-relato.css), controlado
   desde aquí con dos variables CSS por segmento:
   --relato-progreso-dur    (duración = data-autoplay)
   --relato-progreso-estado (running / paused, sigue al autoplay)
   Al activar un segmento se fuerza un reflow antes de añadirle la clase
   «is-activa»: sin eso, si el mismo segmento ya había sido activo antes
   (el carrusel da la vuelta), el navegador puede no reiniciar la animación
   al ver la clase quitada y puesta en el mismo ciclo de estilos. */
(function () {
  'use strict';

  function definir() {
    if (customElements.get('daza-relato-carrusel')) return;

    customElements.define('daza-relato-carrusel', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.listo) return;
        this.dataset.listo = '1';

        var slides = [].slice.call(this.querySelectorAll(':scope > .s-relato__carrusel-pista > .s-relato__slide'));
        var progresos = [].slice.call(this.querySelectorAll('.s-relato__progreso-item'));
        var prevBtn = this.querySelector('.s-relato__flecha--prev');
        var nextBtn = this.querySelector('.s-relato__flecha--next');
        if (slides.length < 2) return;

        var reduce = window.matchMedia('(prefers-reduced-motion:reduce)');
        var intervalo = parseInt(this.dataset.autoplay, 10) || 6000;
        var activo = 0;
        var timer = null;

        function marcar(i) {
          activo = (i + slides.length) % slides.length;

          slides.forEach(function (slide, idx) {
            var esActivo = idx === activo;
            slide.classList.toggle('is-activa', esActivo);
            if (esActivo) {
              slide.removeAttribute('aria-hidden');
            } else {
              slide.setAttribute('aria-hidden', 'true');
            }
          });

          progresos.forEach(function (item, idx) {
            item.classList.remove('is-activa');
            item.classList.toggle('is-vista', idx < activo);
            item.setAttribute('aria-selected', idx === activo ? 'true' : 'false');
          });
          var actual = progresos[activo];
          if (actual) {
            void actual.offsetWidth;
            actual.style.setProperty('--relato-progreso-dur', intervalo + 'ms');
            actual.style.setProperty('--relato-progreso-estado', timer ? 'running' : 'paused');
            actual.classList.add('is-activa');
          }
        }

        function iniciar() {
          if (timer || reduce.matches) return;
          var actual = progresos[activo];
          if (actual) actual.style.setProperty('--relato-progreso-estado', 'running');
          timer = setInterval(function () {
            marcar(activo + 1);
          }, intervalo);
        }
        function detener() {
          clearInterval(timer);
          timer = null;
          var actual = progresos[activo];
          if (actual) actual.style.setProperty('--relato-progreso-estado', 'paused');
        }
        // Cualquier interacción manual reinicia el ciclo desde ese punto,
        // en vez de dejarlo saltar a mitad de camino al siguiente cambio.
        function irA(i) {
          detener();
          marcar(i);
          iniciar();
        }

        marcar(0);
        iniciar();

        this.addEventListener('mouseenter', detener);
        this.addEventListener('mouseleave', iniciar);
        this.addEventListener('focusin', detener);
        this.addEventListener('focusout', iniciar);

        if (prevBtn) prevBtn.addEventListener('click', function () { irA(activo - 1); });
        if (nextBtn) nextBtn.addEventListener('click', function () { irA(activo + 1); });
        progresos.forEach(function (item, idx) {
          var btn = item.querySelector('.s-relato__progreso-btn');
          if (btn) btn.addEventListener('click', function () { irA(idx); });
        });
      }
    });
  }

  definir();
  document.addEventListener('shopify:section:load', definir);
})();
